// @mui material components
import { Grid, Tabs, Tab, Paper } from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "../../components/MDBox";
import MDTypography from "../../components/MDTypography";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";

import { useState } from "react";

// Images
import phantomNodeImg from "../../assets/images/phantom_node.png";

import BundleList from "./BundleList"

import { useLocation } from 'react-router-dom';
import BreakoutTab from "./BreakoutTab";
import IncludedAssetsTab from "./IncludedAssetsTab";
import RelationshipsTab from "./RelationshipsTab";
import ArtifactsTab from "./ArtifactsTab";

import LoadingScreen from "./LoadingScreen";

function BundleAnalysis() {
    const assetCardData = [
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
        {
            image: phantomNodeImg,
            label: "Phantom Node",
            title: "Phantom Node",
            description: "The Phantom Node is a compact, deployable cyber-physical device designed to disrupt, deceive, and dominate smart city ecosystems. This palm-sized tool is a combination of a micro-drone, a cyber-warfare suite, and a signal relay, enabling Special Operations Forces (SOF) to manipulate urban infrastructure, create diversions, and maintain operational superiority in highly surveilled environments.",
            specs: [
                {
                    header: "Dimensions",
                    description: "8cm x 8cm x 4cm (fits in the palm of a hand)."
                },
                {
                    header: "Weight",
                    description: "300g (ultra-portable)."
                },
                {
                    header: "Power Source",
                    description: "Solid-state battery with 48 hours of active operation or 7 days in standby mode."
                },
                {
                    header: "Deployment",
                    description: "Hand-placed, thrown, or launched via a compact pneumatic launcher (up to 50 meters)."
                },
                {
                    header: "Cyber Capabilities",
                    description: "AI-driven intrusion software for hacking into smart city systems (traffic lights, surveillance cameras, IoT devices)."
                },
                {
                    header: "Stealth Features",
                    description: "Radar-absorbent coating, low thermal signature, and silent propulsion (for micro-drone mode)."
                },
                {
                    header: "Singnal Manipulation",
                    description: "Can jam enemy communications, spoof GPS signals, and create false digital signatures to confuse adversaries."
                },
                {
                    header: "Environment Adaptability",
                    description: "Waterproof, dustproof, and EMP-hardened for use in harsh urban conditions."
                },
            ],
            capabilities: [
                {
                    main: "Decoy Creation",
                    value: 100,
                    subset: []
                },
                {
                    main: "Signal Relay",
                    value: 95,
                    subset: []
                },
                {
                    main: "Infiltration Support",
                    value: 85,
                    subset: [
                        {
                            name: "Kinetic",
                            value: 60
                        },
                        {
                            name: "Non-Kinetic",
                            value: 85,
                        }
                    ]
                },
                {
                    main: "Crowd Control",
                    value: 80,
                    subset: []
                },
                {
                    main: "Rapid Exfiltration",
                    value: 70,
                    subset: []
                }
            ]
        },
    ]

    const bundleScoreData = [
    {
        cost: '$5000',
        timeline: '18mo',
        risk: 0.0,
        costScore: 51,
        timeScore: 49,
        riskScore: 100,
        overallScore: 64.0
    },
    ];

    const dummyBundles = [
        {
            bundleName: "bundle1",
            assetCount: 3,
            score: 64
        },
        {
            bundleName: "bundle2",
            assetCount: 4,
            score: 62
        },
        {
            bundleName: "bundle3",
            assetCount: 3,
            score: 53
        },
        {
            bundleName: "bundle4",
            assetCount: 6,
            score: 60
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle5",
            assetCount: 1,
            score: 55
        },
        {
            bundleName: "bundle22",
            assetCount: 5,
            score: 67,
        },
    ]
    const sortedBundlesByScore = [...dummyBundles].sort((a, b) => b.score - a.score);

    const latinDescriptionFiller = "Lorem ipsum odor amet, consectetuer adipiscing elit. Rhoncus vivamus convallis mollis sociosqu quisque praesent eget. Imperdiet iaculis nulla nisl aenean auctor leo. Gravida placerat hendrerit lacinia parturient aptent hendrerit. Habitant porta vehicula nullam conubia mattis id?"
    const dummyRelatedConops = [
        {
            title: "Op1",
            description: latinDescriptionFiller
        },
        {
            title: "Op2",
            description: latinDescriptionFiller
        },
        {
            title: "Op3",
            description: latinDescriptionFiller
        },
        {
            title: "Op4",
            description: latinDescriptionFiller
        },
    ]

    const dummySatisfiedReq = [
        {
            title: "Req1",
            description: latinDescriptionFiller
        },
        {
            title: "Req2",
            description: latinDescriptionFiller
        },
        {
            title: "Req3",
            description: latinDescriptionFiller
        },
        {
            title: "Req4",
            description: latinDescriptionFiller
        },
    ]

    const dummyUnsatisfiedReq = [
        {
            title: "Req1",
            description: latinDescriptionFiller
        },
        {
            title: "Req2",
            description: latinDescriptionFiller
        },
        {
            title: "Req3",
            description: latinDescriptionFiller
        },
        {
            title: "Req4",
            description: latinDescriptionFiller
        },
    ]
  
    const location = useLocation();
    const receivedData = location.state;
    
    const [bottomTabIndex, setBottomTabIndex] = useState(0);
    const [selectedBundleIndex, updateSelectedBundleIndex] = useState(0);
    
    const projectName = receivedData ? receivedData.projectName : "Some Project"

    return (
        <DashboardLayout>
            <MDBox pb={2}>
                <MDTypography variant= "h2">{projectName}</MDTypography>
            </MDBox>
            <MDBox>
                <Grid container spacing={2} sx={{alignItems: "stretch", height: "100%", display:"flex"}}>
                    <Grid item md={4}>
                        <MDBox flex="auto" bgColor="grey-100" borderRadius="lg">
                            <MDBox height="5px"/> 
                            <BundleList 
                                bundleData={sortedBundlesByScore} 
                                updateIndex={updateSelectedBundleIndex}
                                selectedIndex={selectedBundleIndex}
                            />
                        </MDBox>
                    </Grid>
                    
                    <Grid item md={8}>
                        <MDBox flex="auto" bgColor="grey-100" borderRadius="lg">
                            <MDBox height="5px"/> 
                            <Paper sx={{ m: 1, p: 2 }}>
                                <MDTypography variant="h4" textTransform="capitalize">
                                    {sortedBundlesByScore[selectedBundleIndex].bundleName}
                                </MDTypography>
                            </Paper>
                            <MDBox display="flex">
                                <Tabs
                                    value={bottomTabIndex} 
                                    onChange={(_, index) => setBottomTabIndex(index)} 
                                    orientation="horizontal"
                                >
                                    <Tab label="Breakout"/>
                                    <Tab label="Included Assets"/>
                                    <Tab label="Relationships"/>
                                    <Tab label="Artifacts"/>
                                </Tabs>
                            </MDBox>

                            <MDBox flex="auto" bgColor="grey-300" height="100%">
                                {bottomTabIndex === 0 && ( <Grid container>
                                    <BreakoutTab 
                                        scoreData={bundleScoreData} 
                                        relatedConops={dummyRelatedConops} 
                                        satisfiedReq={dummySatisfiedReq}
                                        unsatisfiedReq={dummyUnsatisfiedReq}
                                    />
                                </Grid>)}

                                {bottomTabIndex === 1 && (
                                    <IncludedAssetsTab assetsData={ assetCardData }/>
                                )}

                                {bottomTabIndex === 2 && (
                                    <RelationshipsTab/>
                                )}

                                {bottomTabIndex === 3 && (
                                    <ArtifactsTab/>
                                )}
                            </MDBox>
                        </MDBox>
                    </Grid>
                </Grid>
            </MDBox>
        </DashboardLayout>
    );
}

export default BundleAnalysis;